export default {
    'Mega Menu': 'Mega meni',
    Menu: 'Izbornik',
    Calendar: 'Kalendar',
    Chat: 'Pričaonica',
    Ecommerce: 'Elektronska trgovina',
    Products: 'Proizvodi',
    'Product Detail': 'Detalji o proizvodima',
    Orders: 'Narudžbe',
    Customers: 'Kupci',
    Customer: 'Korisnik',
    Cart: 'Korpa',
    Checkout: 'Odjava',
    Shops: 'Prodavnice',
    'Add Product': 'Dodajte proizvod',
    Email: 'Email',
    Inbox: 'Inbox',
    'Read Email': 'Čitati poštu',
    'Kanban Board': 'Kanban tabla',
    Layouts: 'Pregledi',
    Horizontal: 'Horizontalno',
    'Dark Sidebar': 'Tamni bočni prozor',
    'Default Sidebar': 'Pretpostavljeni bočni prozor',
    'Compact Sidebar': 'Kompaktni bočni prozor',
    'Icon Sidebar': 'Ikona bočnog prozora',
    'Boxed Layout': 'Boxed Layout',
    'Fluid Layout': 'Fluid Layout',
    Preloader: 'Preloader',
    'Without Preloader': 'Bez preloader',
    Pages: 'Stranice',
    Authentication: 'Autentikacija',
    Login: 'Prijavite se',
    Register: 'Registrovajte se',
    'Recover Password': 'Obnovi lozinku',
    'Lock Screen': 'Zaključavanje ekrana',
    Utility: 'Utility',
    'Starter Page': 'Početna stranica',
    Maintenance: 'Održavanje',
    'Coming Soon': 'Dolazi uskoro',
    Timeline: 'Vremenska linija',
    FAQs: 'Česta pitanja',
    Pricing: 'Cenik',
    'Error 404': 'Greška 404',
    'Error 500': 'Greška 500',
    Components: 'Komentari',
    'UI Elements': 'UI elementi',
    Alerts: 'Alerts',
    Buttons: 'Buttons',
    Cards: 'Cards',
    Carousel: 'Karusel',
    Dropdowns: 'Dropdowns',
    Grid: 'Rešetka',
    Images: 'Slike',
    Lightbox: 'Lightbox',
    Modals: 'Modali',
    'Range Slider': 'Klizač dometa',
    'Round Slider': 'Okrugli klizač',
    'Session Timeout': 'Cremensko ograničenje sesije',
    'Progress Bars': 'Trake napredka',
    'Sweet Alerts': 'Sweet Alerts',
    'Tabs & Accordions': 'Tabulatori i harmonika',
    Typography: 'Tipografija',
    Video: 'Video',
    General: 'Generalno',
    Rating: 'Ocena',
    Notifications: 'Obaveštenja',
    Forms: 'Obrasci',
    Elements: 'Elementi',
    Validation: 'Validacija',
    'Advanced Plugins': 'Advanced Plugins',
    Editors: 'Editors',
    'File Upload': 'Otpremanje datoteke',
    'X-editable': 'X-editable',
    Wizard: 'Pomoćnik',
    Mask: 'Maska',
    Tables: 'Tabela',
    'Basic Tables': 'Osnovne tabele',
    'Data Tables': 'Data tabele',
    'Responsive Table': 'Responzivne tabele',
    'Editable Table': 'Tabele za uređivanje',
    Charts: 'Grafikoni',
    Apexcharts: 'Apexcharts',
    Chartist: 'Chartist',
    Chartj: 'Chartj',
    'Jquery Knob': 'Jquery Knob',
    Sparkline: 'Sparkline',
    Icons: 'Ikone',
    'Remix Icons': 'Remix ikone',
    'Material Design': 'Material dizajn',
    Dripicons: 'Dripicons',
    'Font awesome 5': 'Font awesome 5',
    Maps: 'Mape',
    'Google Maps': 'Google Maps',
    'Vector Maps': 'Vector Maps',
    'Multi Level': 'Više nivoa',
    'Level 1.1': 'Nivo 1.1',
    'Level 1.2': 'Nivo 1.2',
    'Level 2.1': 'Nivo 2.1',
    'Level 2.2': 'Nivo 2.2',
    Profile: 'Profil',
    'My Wallet': 'Moj novčanik',
    Settings: 'Podešavanja',
    'View more': 'Pogledaj više',
    'View all': 'Pogledaj sve',
    Logout: 'Odjavite se',
    'Your order is placed': 'Vaša narudžba je izvršena',
    'If several languages coalesce the grammar': 'Ako nekoliko jezika spaja gramatiku',
    'Your item is shipped': 'Vaša stavka je isporučena',
    '3 min ago': 'Pre 3 minuta',
    'James Lemire': 'Džejms Lemir',
    'It will seem like simplified English.': 'Izgledac̘e kao pojednostavljeni engleski.',
    '1 hours ago': 'Pre 1 sat',
    'Salena Layfield': 'Salena Lajfild',
    'As a skeptical Cambridge friend of mine occidental.': 'Kao moj skeptični prijatelj sa Kembridža.',
    'View More..': 'Pogledaj još..',
    'UI Components': 'UI Components',
    Applications: 'Aplikacije',
    'Extra Pages': 'Dodatne stranice',
    Github: 'Github',
    Bitbucket: 'Bitbucket',
    Dribble: 'Dribble',
    Dropbox: 'Dropbox',
    'Mail Chimp': 'Mail Chimp',
    Slack: 'Slack',
    'Offer Calculator': 'Digitalni kalkulator',
    'No offers that meet this conditions.': 'Nije pronađena ponuda prema zadanim uvetima.',
    'Calculation done': 'Kalkulacija je završena'
};
